import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import type { NonGenerativeAIAnswerResultShownProps } from '../ai-answer-dialog/types';

// since some experiences don't have a plain text answer (e.g. Jira Issue Knowledge Card)
export const onNonGenerativeKnowledgeCardLinkClick = (
	props: NonGenerativeAIAnswerResultShownProps,
): AnalyticsEventPayload => {
	const {
		answerString,
		brand,
		query,
		queryHash,
		searchSessionId,
		source,
		targetMarker,
		answerCardType,
		location,
		isAuxClick,
		isContextMenu,
		queryLength,
		wordCount,
		queryIntent,
		jiraNlToJqlCardVariant,
		elementInteracted,
		imageCount,
		imageIndex,
		imageSimilarity,
		imageMaxVisibleCount,
	} = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerDialog',
		actionSubjectId: 'knowledgeCardLink',
		source: source,
		eventType: 'track',
		attributes: {
			brand,
			queryHash,
			searchSessionId,
			targetMarker,
			location,
			answerCardType,
			isAuxClick,
			isContextMenu,
			queryLength,
			wordCount,
			queryIntent,
			jiraNlToJqlCardVariant,
			elementInteracted,
			imageCount,
			imageIndex,
			imageSimilarity,
			imageMaxVisibleCount,
		},
		nonPrivacySafeAttributes: {
			answerString,
			query,
		},
	};
};
